import * as React from 'react';
import { Image } from '@cian/ui-kit';
import * as styles from './Logo.css';

export interface ILogoProps {
  src?: string | null;
  name?: string | null;
}

export const Logo: React.FC<ILogoProps> = props => {
  const { src, name } = props;

  if (!src) {
    return (
      <div className={styles['logo-default']}>
        <div className={styles['logo-default-content']}>{name && name[0]}</div>
      </div>
    );
  }

  return (
    <div className={styles['logo']}>
      <div className={styles['logo-image']}>
        <Image src={src} />
      </div>
    </div>
  );
};
